import * as React from "react";

import {to_isAddressable} from "@Common/logic/template-options/template-options-is-addressable";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Invoke}           from "@Common/react/invoke";
import {isDevQuan}        from "@Common/ui-components/debug/is-dev-quan";
import {buildUrlQuery}    from "@Common/utils/build-url-query";

import {EnsureItemAddedToCart} from "../../../../common/logic/cart-logic/ensure-item-added-to-cart";
import {Layout}                from "../../../../layout/layout";

export const RedirectedFromPHP = ({item,templateOptions, query, next}) => cs(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("routerHistory"),
    ["ensureItemAddedToCart", ({}, next) => EnsureItemAddedToCart({next})],
    ({apis, ensureItemAddedToCart, company, routerHistory}) => (
        (
            isDevQuan() ||
            templateOptions.distributions.includes("mailing") ||
            (
                (templateOptions.distributions.includes("shipping") || templateOptions.distributions.includes("pickup")) &&
                to_isAddressable(templateOptions)
            ) ||
            false
        ) ? (
            next()
        ) : <>
            {Invoke({
                fn: () => updateAndCheckout({query, apis, item, ensureItemAddedToCart, routerHistory}),
            })}
            <Layout className="customize-layout-95r">
                <div className="product-options-step-6rz">
                    <div className="center">
                        Redirecting to Checkout...
                    </div>
                </div>
            </Layout>
        </>
    ),
);


const updateAndCheckout = async ({apis, item, query, ensureItemAddedToCart, routerHistory}) => {
    if (query?.referrer === "approval-requests") {
        const cartId = query.id_cart ?? query.cart_id;
        if (cartId == null) {
            alert("Error: No cart id found");
            return;
        }
        routerHistory.replace(`/checkout/${cartId}` + buildUrlQuery({
            referrer: query.referrer,
        }));
    } else {
        const {cartId} = await ensureItemAddedToCart({
            item,
        });

        await apis.next.session.clearSessionOrder();
        routerHistory.replace(`/checkout/${cartId}`);
    }

};
